import { defineStore } from "pinia";

export const useCategoryStore = defineStore("category", () => {
  const state = useState('categoryState', () => ({
    categories: [] as any[],
    categoriesLoading: false,
    categoryId: null as any,
    categorySlug: null as any,
    categoryName: null as any,
    providers: [] as any[]
  }));

  const fetchCategoriesGames = async () => {
    try {
      const { data } = await useFetch("/v2/casino-games/category");
      state.value.categories = data.value || [];
      state.value.categoriesLoading = false;
    } catch (error) {
      console.error("Error fetching categories:", error);
      state.value.categoriesLoading = false;
    }
  };

  const fetchProvidersByCategory = async (categoryId: string) => {
    try {
      const { data } = await useFetch(`/v2/casino-games/category/${categoryId}/providers`);
      state.value.providers = data.value || [];
    } catch (error) {
      console.error("Error fetching providers by category:", error);
      state.value.providers = [];
    }
  };

  return {
    state,
    fetchCategoriesGames,
    fetchProvidersByCategory,
  };
});
